import { Link } from "react-router-dom";

export function MuscleSchoolBanner() {
  return (
    <Link
      to="/themuscleschool"
      data-testid="tms-announcement-banner"
      aria-label="Enrollment Open: The Muscle School — go to enrollment"
      className="tms-banner-glint relative block w-full border-y border-[#c9962c]/30"
      style={{ background: "linear-gradient(180deg, #2b0d12, #210a0e)" }}
    >
      <div className="relative z-10 max-w-[1600px] mx-auto px-4 md:px-8 py-2.5 flex items-center justify-center gap-2.5">
        <img src="/tms/seal.png" alt="" className="w-4 h-4 rounded-full object-cover shrink-0 hidden sm:block" />
        <p className="font-display text-[9px] tracking-[0.06em] sm:text-xs sm:tracking-[0.18em] uppercase text-center leading-snug whitespace-nowrap" style={{ color: "#f4ead9" }}>
          <span style={{ color: "#c9962c" }}>Enrollment Open:</span> The Muscle School
        </p>
      </div>
    </Link>
  );
}
